export default __webpack_public_path__ + "static/media/home-track-mobile-blue.c129a414.svg";